module.exports = fox._r("images/about-img.jpg", __webpack_public_path__ + "images/about-img.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/about-img.jpg
// module id = 968
// module chunks = 4